<app-loading-screen *ngIf="isLoading$ | async"></app-loading-screen>
<div class="app-wrapper" [ngClass]="wrapperClasses$ | async">
  <app-sidebar *ngIf="currentUser$ | async"></app-sidebar>
  <main class="main-content">
    <header class="app-header" *ngIf="currentUser$ | async">
      <button class="btn btn-icon sidebar-toggle sidebar-toggle-button" (click)="sidebarService.toggle()">
        <i class="bi bi-list"></i>
      </button>
    </header>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
